<p-card [class]="{'w-full':true, 'flex-grow':true, 'min-h-0':true, 'greedy-card':true,'rounded-tl-[0]':usedWithTabs}">
  @if (hasHeader) {
    <ng-template pTemplate="header">
      <div class="card-header flex justify-between items-center">
        <ng-content select="[header]"></ng-content>
        <ng-content select="[headerActions]"></ng-content>
      </div>
    </ng-template>
  }
  <div class="flex flex-col w-full flex-grow min-h-0 px-[3.25rem] pt-[1.25rem] pb-[1.25rem]">
    <ng-content></ng-content>
  </div>
  @if (hasFooter) {
    <ng-template pTemplate="footer">
      <ng-content select="[footer]"></ng-content>
    </ng-template>
  }
</p-card>
